import React, {useState} from 'react';
import CodeSentIcon from '../Assets/SVG/codeSentIcon';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import {TextInputEnum, validateInput} from '../../../../utilities/validation/InputValidation';

const PaypalEmailEntry = (props) => {
  const [paypalEmail, setPaypalEmailInput] = useState('');
  const [errorInForm, setErrorForm] = useState(null);

  const validateEmail = async () => {
    const validationError = validateInput(paypalEmail, TextInputEnum.Mail);
    if (validationError) {
      setErrorForm(validationError);
      return false;
    }
    const isRightEmail = await props.onclick(paypalEmail);

    if (!isRightEmail) {
      setErrorForm('כתובת האימייל שהקלדתם לא תואמת את זו שיש אצלנו, שננסה שוב?');
    }
  };

  return (
    <div className='screenContainer'>
      <form
        action='#'
        onSubmit={async (e) => {
          e.preventDefault();
          await validateEmail();
        }}>
        <CodeSentIcon />
        <h3 className='heading withSecondary'>מהי כתובת ה-PayPal שלכם?</h3>
        <h3 className='secondaryHeading'>
          רק רוצים לוודא שאתם זה אתם :)
          <br />
          ולא אף אחד אחר
        </h3>
        <TextInput
          placeholder={'כתובת PayPal'}
          value={paypalEmail}
          error={errorInForm}
          type='email'
          inputMode='email'
          autoComplete='email'
          onChange={(e) => {
            setPaypalEmailInput(e.target.value);
            setErrorForm(null);
          }}
        />
        <Footer onclick={PaypalEmailEntry} stage={props.stage} />
      </form>
    </div>
  );
};

export default PaypalEmailEntry;
